const e = {
  primary: "#121212",
  secondary: "#10a37f",
  tertiary: "#808080",
  textPrimary: "#0d0d0d",
  textSecondary: "#6e6e80",
  textTertiary: "#9ca3af"
};
function y(r, t = document.documentElement) {
  t.style.setProperty("--brand-primary-color", r.primary), t.style.setProperty("--brand-secondary-color", r.secondary), t.style.setProperty("--brand-tertiary-color", r.tertiary), t.style.setProperty("--text-primary-color", r.textPrimary), t.style.setProperty("--text-secondary-color", r.textSecondary), t.style.setProperty("--text-tertiary-color", r.textTertiary);
}
export {
  e as DEFAULT_THEME,
  y as applyThemeCssVars
};
